module.exports = __webpack_public_path__ + "media/images/1200/narcolepsy_moon_mountains-33adb3b58156f42b0fc1aec7a00fea7e.jpg";